/* dev-header — drawer toggle + ESC/backdrop close.
   Idempotent (data-dev-header-bound) so re-running on shopify:section:load
   doesn't double-bind. */

(function () {
  function bindHeader(header) {
    if (header.dataset.devHeaderBound === 'true') return;
    header.dataset.devHeaderBound = 'true';

    const toggle = header.querySelector('[data-dev-header-toggle]');
    // Drawer + backdrop are SIBLINGS of `<header>` (hoisted out so the
    // header's `backdrop-filter` doesn't cap their fixed positioning to the
    // header's bounding box). Query from document scope, not `header`.
    const drawer = document.querySelector('.dev-header__drawer');
    const backdrop = document.querySelector('[data-dev-header-backdrop]');
    const closeBtn = drawer && drawer.querySelector('[data-dev-header-close]');
    if (!toggle || !drawer || !backdrop) return;

    function open() {
      drawer.hidden = false;
      backdrop.hidden = false;
      // Force a reflow so the transition runs on the next frame
      drawer.offsetHeight;
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      // Hide after the slide-out finishes
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
          backdrop.hidden = true;
        }
      }, 300);
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    backdrop.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Cart icon → open the stock cart drawer (mounted via `block-cart` inside
    // the section). Mirrors theme.miniCart's toggle behavior. Falls back to
    // navigating /cart if the drawer markup isn't on the page.
    const cartTrigger = header.querySelector('[data-dev-header-cart]');
    if (cartTrigger) {
      cartTrigger.addEventListener('click', function (e) {
        const cartDrawerWrap = document.querySelector('.dev-header__cart-mount .js-mini-cart.cardraw')
          || document.querySelector('.dev-header__cart-mount .js-mini-cart');
        if (!cartDrawerWrap) return; // graceful: <a href="/cart"> navigates
        e.preventDefault();
        cartDrawerWrap.classList.toggle('active');
      });
    }

    // Search icon → toggle the `.search-modal modal__content gradient` panel
    // rendered by the `header-search` snippet inside `.dev-header__search-mount`.
    // We toggle the `.active` class directly here instead of relying on
    // theme.js's `headerSearch()` because that function chains
    // `addEventListener` on multiple `document.querySelector` results and
    // throws on the first null — fragile if any selector misses. Mirror its
    // public behavior (toggle `.detail-modal.active`, toggle
    // `.modal-overlay.active`, focus `#Search-In-Modal`) so the visual
    // outcome matches the legacy header.
    const searchMount = document.querySelector('.dev-header__search-mount');
    const detailModal = searchMount && searchMount.querySelector('.detail-modal');
    const searchModal = searchMount && searchMount.querySelector('.search-modal');
    const searchOverlay = searchMount && searchMount.querySelector('.modal-overlay');
    const searchInput = searchMount && searchMount.querySelector('#Search-In-Modal');
    const searchClose = searchMount && searchMount.querySelector('.search-modal__close-button');

    function isSearchOpen() {
      return (detailModal && detailModal.classList.contains('active')) ||
        (searchModal && searchModal.classList.contains('active'));
    }

    function closeSearchModal() {
      if (detailModal) detailModal.classList.remove('active');
      if (searchModal) searchModal.classList.remove('active');
      if (searchOverlay) searchOverlay.classList.remove('active');
      // Note: do NOT set `display: none` on `.predictive-search` here.
      // The `<predictive-search>` custom element (assets/predictive-search.js)
      // manages its own visibility via the `[open]` attribute and inline
      // `max-height` style; forcing `display: none` from outside fights its
      // logic and prevents results from re-appearing on the next search.
      if (searchInput) searchInput.value = '';
    }

    function openSearchModal() {
      // Toggle on BOTH `.detail-modal` and the modal element itself so the
      // CSS rule fires whether the snippet wraps in `.detail-modal` or not.
      if (detailModal) detailModal.classList.add('active');
      if (searchModal) searchModal.classList.add('active');
      if (searchOverlay) searchOverlay.classList.add('active');
      // Defer focus past the slide-in transition so the keyboard appears
      // after the modal lands, not while it's still moving.
      window.setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 50);
    }

    // Search triggers live in two places now: the utility cluster inside
    // `<header>` (desktop) and the drawer's utility row outside `<header>`
    // (mobile). Query from document scope to catch both.
    const searchTriggers = document.querySelectorAll('[data-dev-header-search]');
    searchTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        if (!searchMount || (!detailModal && !searchModal)) return; // graceful: <a href="/search"> navigates
        e.preventDefault();
        // If the mobile drawer is open, close it first so the search modal
        // isn't stacked behind the drawer's z-index.
        if (drawer.classList.contains('is-open')) close();
        if (isSearchOpen()) {
          closeSearchModal();
        } else {
          openSearchModal();
        }
      });
    });

    if (searchOverlay) searchOverlay.addEventListener('click', closeSearchModal);
    if (searchClose) searchClose.addEventListener('click', function (e) {
      e.preventDefault();
      closeSearchModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isSearchOpen()) {
        closeSearchModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Close when transitioning to desktop viewport
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1281 && drawer.classList.contains('is-open')) {
        close();
      }
    });
  }

  function init() {
    document.querySelectorAll('.dev-header').forEach(bindHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const header = e.target.querySelector('.dev-header') ||
      (e.target.classList && e.target.classList.contains('dev-header') ? e.target : null);
    if (header) bindHeader(header);
  });
})();
